import parse, { domToReact, HTMLReactParserOptions } from "html-react-parser";
import { parseDocument } from "htmlparser2";
import { DomUtils } from "htmlparser2";

// Takes an HTML snippet and returns whatever react component you want to replace specific tags with
export const htmlToReactComponents = (html: string) => {
  const options: HTMLReactParserOptions = {
    replace: (domNode) => {
      if (domNode.type === "tag") {
        const { name, attribs, children } = domNode as any;

        switch (name) {
          case "p":
            return domToReact(children, options);
          case "h2":
            return domToReact(children, options);
          case "a":
            return domToReact(children, options);
          default:
            return domNode;
        }
      }
    },
  };

  return parse(html, options);
};

// Takes an HTML list and returns an array of strings
export const extractBulletPoints = (html: string): string[] => {
  const document = parseDocument(html);
  const bulletPoints: string[] = [];

  const ulElements = DomUtils.findAll(
    (elem) => elem.name === "ul",
    document.children,
  );

  ulElements.forEach((ul) => {
    const liElements = DomUtils.findAll(
      (elem) => elem.name === "li",
      ul.children,
    );
    liElements.forEach((li) => {
      bulletPoints.push(DomUtils.textContent(li));
    });
  });

  return bulletPoints;
};

// Takes an HTML string and returns a string without HTML tags
export const stripHtml = (input: string): string => {
  if (!/<[a-z][\s\S]*>/i.test(input)) {
    return input; // Return the original input if there's no HTML
  }
  return input.replace(/<\/?[^>]+(>|$)/g, "").trim();
};
